import { Col } from "reactstrap";
import { H6 } from "../../../../AbstractElements";
import { AdditiveBorderTitle } from "../../../../Constants/Constants";
import { AdditiveBorderData } from "../../../../Data/UiKits/HelperClasses";

const AdditiveBorder = () => {
  return (
    <Col xl="4" sm="6">
      <div className="border-wrapper h-100 border">
        <H6 className="mb-3">{AdditiveBorderTitle}</H6>
        {AdditiveBorderData &&
          AdditiveBorderData.map((item, index) => (
            <div className="helper-common-box" key={index}>
              <div className={`helper-box bg-light ${item}`} />
              <span>{`.${item}`}</span>
            </div>
          ))}
      </div>
    </Col>
  );
};
export default AdditiveBorder;
